import 'bootstrap';
import 'x-editable/dist/bootstrap3-editable/js/bootstrap-editable.min.js';

import '../src/stylesheets/application.sass';
import '../src/javascripts/default.js.coffee';
import '../src/images'



